import { useEffectOnce } from '@dni-react-hooks/use-effect-once'
import { USER_ROLE } from '../constants'
import { useStmBrandStore } from './use-stm-brand-store'

/**
 * 特定角色進入頁面時，自動清除 currentBrand 以顯示所有品牌。
 * 其他角色不受影響，保留原有的 currentBrand。
 */
export const useResetBrandOnEntry = (): void => {
  const { userRole, setBrand } = useStmBrandStore()

  useEffectOnce(() => {
    const resetBrandOnEntry = () => {
      if (userRole === USER_ROLE.PARTNER) {
        setBrand(null)
      }
    }
    resetBrandOnEntry()
  })
}
